import React from "react";
import AxiosConfig from "axiosConfig";
import { connect } from "react-redux";
import CustomBanner from "components/General/Form/CustomBanner";
import Logo404 from "site_media/images/404.jpg";

class Error extends React.Component {
  componentDidMount() {
    const props = this.props;
    AxiosConfig.post(`account/exit/`, this.state).then(function (response) {
      props.dispatch({ type: "LOGOUT_SUCCESS" });
    });
  }

  render() {
    return (
      <div>
        <CustomBanner message="This is not the webpage you are looking for." />
        <div style={{ textAlign: "-webkit-center" }}>
          <img src={Logo404} alt="404Error" style={{ width: "90%" }} />
        </div>
      </div>
    );
  }
}

export default connect()(Error);
